import { useEffect, useState } from "react";
import useSocket from "hooks/useSocket";
import { SOCKET_SERVER_NAMESPACES } from "static/constants";

const useDashboardReportPresence = (reportIds = []) => {
  const socket = useSocket(SOCKET_SERVER_NAMESPACES.REPORT_PRESENCE);
  const [presenceMap, setPresenceMap] = useState({});

  useEffect(() => {
    if (!socket || reportIds.length === 0) return;

    const handlePresenceUpdate = (updates) => {
      setPresenceMap((prev) => {
        const next = { ...prev };
        updates.forEach(({ reportId, users }) => {
          next[reportId] = users;
        });
        return next;
      });
    };

    const subscribeToReports = () =>
      socket.emit("dashboard:reports:subscribe", { reportIds });

    socket.on("dashboard:reports:presence", handlePresenceUpdate);
    socket.on("socket:ready", subscribeToReports);

    if (socket.isReady) {
      subscribeToReports();
    }

    return () => {
      socket.emit("dashboard:reports:unsubscribe", { reportIds });
      socket.off("dashboard:reports:presence", handlePresenceUpdate);
      socket.off("socket:ready", subscribeToReports);
    };
  }, [reportIds, socket]);

  return presenceMap;
};

export default useDashboardReportPresence;
